import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';

import {AppRoutes} from './app.routes';
import {AppComponent} from './app.component';
import {AppMenuComponent, AppSubMenuComponent} from './app.menu.component';
import {AppTopBarComponent} from './app.topbar.component';
import {AppFooterComponent} from './app.footer.component';
import {AppBreadcrumbComponent} from './app.breadcrumb.component';

import {BreadcrumbService} from './breadcrumb.service';
import {TitleService} from './title.service';
import {AppRouteReuseStrategyService} from './route-reuse-strategy.service';
import {TopbarService} from './topbar.service';
import {AdminModule, DashboardModule, ProfileModule, ProjectModule, UserModule} from './modules';
import {CoreModule} from './core/core.module';
import {PrimeNGModule} from './core';
import {Interceptor} from './app.interceptor';
import {AuthComponent} from './core/auth';
import {MessagesComponent, PasswordRecoverComponent} from './core/components';
import {ProjectSidebarService} from './projectsidebar.service';
import {ProjectSidebarComponent} from './modules/project/components';
import {RouteReuseStrategy} from '@angular/router';
import {SwaggerComponent} from './swagger.component';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        AppRoutes,
        HttpClientModule,
        BrowserAnimationsModule,
        PrimeNGModule,
        CoreModule,
        DashboardModule,
        ProjectModule,
        AdminModule,
        ProfileModule,
        UserModule
    ],
    declarations: [
        AppComponent,
        AppMenuComponent,
        ProjectSidebarComponent,
        AppSubMenuComponent,
        AppTopBarComponent,
        AppFooterComponent,
        AppBreadcrumbComponent,
        // our components
        AuthComponent,
        MessagesComponent,
        PasswordRecoverComponent,
        SwaggerComponent
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true },
        { provide: RouteReuseStrategy, useClass: AppRouteReuseStrategyService},
        BreadcrumbService, TitleService, ProjectSidebarService, TopbarService
    ],
    bootstrap: [AppComponent],
    exports: []
})
export class AppModule { }

